<template>
    <div class="share">
        <div class="header-video"
             v-if="url">
            <Video :id="'video-' + id"
                   :url="url"
                   :poster="poster"
                   :width="width"
                   :height="height"
                   :autoplay="true">
            </Video>
        </div>
    </div>
</template>

<script>
import Video from "../video"
import jsonp from 'jsonp';

export default {
    name: "SmallVideo",
    data () {
        return {
            id: this.$route.params.id,
            url: null,
            poster: null,
            width: "100%",
            height: "100%",
        }
    },
    components: {
        Video
    },
    methods: {
        getSmallVideo () {
            this.axios.get("/videos/id/" + this.id).then(res => {
                let data = res.data.data
                this.url = data.videoUrl
                this.poster = data.coverUrl
                document.title = data.title
                document.shareImage = data.coverUrl
            })
        },
        getStatistPv () {
            jsonp(`https://dcy.gxnews.com.cn/insert.php?myurl=${encodeURIComponent('https://zgapp.gxnews.com.cn/h5/#/video/'+this.id)}&tag=zgapp-video&t=${Math.random()}`, {} , (err, data) => {
                if (err) {
                    console.error(err.message);
                } else {
                    console.log('请求成功');
                }
            })
        }
    },
    mounted () {
        this.getSmallVideo();
        this.getStatistPv();
    }
}
</script>

<style scoped>
.share {
    background: #000;
    width: 100%;
    height: 100%;
    position: relative;
}
.header-video,
.video-wrap,
.header-video div {
    height: 100%;
    width: 100%;
}
.vcp-player {
    position: relative;
    z-index: 0;
    font-family: Tahoma, "\5FAE\8F6F\96C5\9ED1", \u5b8b\u4f53, Verdana, Arial,
        sans-serif;
    background-color: black;
}
</style>
